export default "__VITE_ASSET__CNt2GQqd__"